import React from "react";
import { connect } from "react-redux";
import { RewardOfflineDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import {
  REWARD_RENDER_TYPE,
  REDER_REWARD_E_VOUCHER_STATUS,
} from "utils/functions/reward";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import * as XLSX from "xlsx";
import moment from "moment";
import momentTZ from "moment-timezone";
import queryString from "query-string";
import QRCode from "react-qr-code";
import { ROUTE_PATH } from "utils/constants/routePath";
import { EVoucherAddToCusWidget } from "widgets";
import { Buttons, Displays, Inputs, Modals, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class RewardOfflineDetailContainer extends React.Component {
  state = {
    isLoading: true,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (queryString) => {
    let resArr = await Promise.all([
      portalService.GET_REWARD_DETAIL(this.props.router.params.id),
      portalService.GET_REWARD_VOUCHER(
        this.props.router.params.id,
        queryString
      ),
      portalService.GET_REWARD_E_VORCHER_STATISTIC_STATUS(
        this.props.router.params.id
      ),
    ]);
    if (resArr) {
      this.setState({
        data: resArr[0].data,
        rewardHistorydata: resArr[1].data,
        rewardEVoucherStatisticStatus: resArr[2].data,
        pagination: {
          last_page: resArr[1].data.totalPages,
          current_page: resArr[1].data.page,
          total: resArr[1].data.totalDocs,
          per_page: resArr[1].data.limit,
        },
        isLoading: false,
        isBgLoading: false,
        isLoadingTable: false,
      });
    }
  };

  fetchRewardVoucherData = async (queryString) => {
    let res = await portalService.GET_REWARD_VOUCHER(
      this.props.router.params.id,
      queryString
    );
    if (res && res.status === 200) {
      this.setState({
        rewardHistorydata: res.data,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
        isLoading: false,
        isBgLoading: false,
        isLoadingTable: false,
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoadingTable: true,
    });
    this.props.router.navigate(
      `${ROUTE_PATH.REWARD}/offline/${this.props.router.params.id}${joinQuery}`
    );
    this.fetchRewardVoucherData(joinQuery);
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  handleExport = async () => {
    const { data, filterQuery } = this.state;
    this.setState({ isBgLoading: true });
    this.setState({ isBgLoading: true });
    let joinQuery = filterQuery
      ? `${filterQuery}&date_type=redeemed_at&pagination=false`
      : `?date_type=redeemed_at&pagination=false`;
    let res = await portalService.GET_REWARD_VOUCHER(
      this.props.router.params.id,
      joinQuery
    );
    if (res && res.status === 200) {
      const wb = XLSX.utils.book_new();
      const ws_name = "Reward Data";

      const ws_data = res.data?.docs?.map((item, index) => {
        const usedDates = Array.from({ length: data?.time_to_use || 1 }).map(
          (_, i) =>
            item.used_list?.[i]
              ? momentTZ(item.used_list[i])
                  .tz("Asia/Bangkok")
                  .format("DD/MM/YYYY HH:mm")
              : "-"
        );

        return [
          index + 1,
          item._id || "-",
          REDER_REWARD_E_VOUCHER_STATUS(item.status),
          item?.first_name ? `${item.first_name} ${item.last_name}` : "-",
          item?.phone_number || "-",
          item?.time_to_use || "-",
          item?.used || "-",
          ...usedDates,
          item?.product_th || "-",
          item?.instrument_serial_no || "-",
        ];
      });

      const headers = [
        "No",
        "Code",
        "Status",
        "Name",
        "Phone",
        "Time to Use",
        "Used",
        ...Array.from({ length: data?.time_to_use || 1 }).map(
          (_, i) => `Used Date ${i + 1}`
        ),
        "Instrument",
        "Serial No",
      ];

      ws_data.unshift(headers);

      const ws = XLSX.utils.aoa_to_sheet(ws_data);

      ws["!cols"] = [
        { wch: 5 },
        { wch: 20 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 10 },
        { wch: 15 },
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, ws_name);

      XLSX.writeFile(
        wb,
        `reward-viewcode-export-${moment().format("YYYYMMDD_HHmmss")}.xlsx`
      );
    }
  };

  handleCancel = () => {
    this.props.router.navigate(-1);
  };

  render() {
    const { authenRedux, router } = this.props;
    const {
      isLoading,
      isLoadingTable,
      isBgLoading,
      data,
      rewardHistorydata,
      rewardEVoucherStatisticStatus,
      pagination,
      renderModal,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "reward");
    return (
      <RewardOfflineDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <div className="block_section">
              <div className="title">View Code</div>
              <div className="sub_title">ข้อมูลของรางวัล</div>
              <div className="body">
                <div className="body_left">
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      leftWidth="200px"
                      label={"Reward Code"}
                      value={data.reward_code}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      leftWidth="200px"
                      label={"Reward Name"}
                      value={data.name}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      leftWidth="200px"
                      label={"Reward Type"}
                      value={REWARD_RENDER_TYPE(data.type)}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      leftWidth="200px"
                      label={"จำนวนทั้งหมด"}
                      value={`${data.total_amount}`}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      leftWidth="200px"
                      label={"Active (ยอดคงเหลือ)"}
                      value={`${rewardEVoucherStatisticStatus.active}`}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      leftWidth="200px"
                      label={"Redeemed คงค้างที่ยังไม่ได้ใช้"}
                      value={`${rewardEVoucherStatisticStatus.redeemed}`}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      leftWidth="200px"
                      label={"Used"}
                      value={`${rewardEVoucherStatisticStatus.used}`}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      leftWidth="200px"
                      label={"Expired"}
                      value={`${rewardEVoucherStatisticStatus.expired}`}
                    />
                  </div>
                </div>
                <div className="body_right">
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      label={"Passcode"}
                      value={
                        data.is_single_passcode_active
                          ? data.single_passcode
                          : "-"
                      }
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      label={"QR code"}
                      value={
                        data.is_qr_code_active ? (
                          // ไม่ตั้ง id ให้ QRCode เพราะเป็น id ตายตัว ถ้าวันไหนวางหลายใบในหน้าเดียว
                          // id จะซ้ำกัน แล้ว getElementById จะหยิบใบแรกเสมอ — ถ้าต้องอ้างถึงให้ใช้ ref
                          <QRCode
                            title="Yamaha activity qrcode"
                            value={`/${data._id}/e-voucher`}
                            size={120}
                          />
                        ) : (
                          "-"
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="line" />
            {/* <div className="filter_wrap">
              <Inputs.InputFilter
                theme_standard_input_filter
                dataFilter={[]}
                btnLabel="ค้นหา"
                onQueryFilter={this.handleFilterKeyword}
                onExport={
                  permission &&
                  (permission.is_export || permission.is_export_condition)
                    ? () => this.handleExport(permission)
                    : false
                }
              />
            </div> */}
            <Inputs.InputFilter
              theme_standard_input_filter
              dataFilter={dataFilter(router.location?.search)}
              btnLabel="ค้นหา"
              onQueryFilter={this.handleFilterKeyword}
              onExport={
                permission &&
                (permission.is_export || permission.is_export_condition)
                  ? () => this.handleExport(permission)
                  : false
              }
            />
            {isLoadingTable ? (
              <Displays.Loading theme_standard_loading />
            ) : (
              <div className="body_table">
                <Tables.Standard
                  columns={columns({
                    permission: permission,
                    time_to_use: data?.time_to_use,
                    onSuccess: () => this.handleJoinQuery(),
                  })}
                  data={rewardHistorydata.docs}
                  showPagination
                  pagination={pagination}
                  handlePageClick={this.handlePageClick}
                  onChangePerPage={this.handlePerPageChange}
                />
              </div>
            )}
            <div className="btn_wrap">
              <div className="w120">
                <Buttons.BgStandard label="Back" onClick={this.handleCancel} />
              </div>
            </div>
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </RewardOfflineDetailContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "cus_name",
      length: "311px",
      filter: {
        fieldQuery: "cus_name",
        defaultValue: initialValues["cus_name"],
        type: "text",
        label: "Name",
        placeholder: "Name",
      },
    },
    {
      accessor: "phone_number",
      length: "311px",
      filter: {
        fieldQuery: "phone_number",
        defaultValue: initialValues["phone_number"],
        type: "text",
        label: "Phone",
        placeholder: "",
      },
    },
    {
      accessor: "status",
      length: "311px",
      filter: {
        fieldQuery: "status",
        defaultValue: initialValues["status"],
        type: "dropdown",
        label: "Status",
        placeholder: "All",
        options: [
          {
            label: "Active/ ready to use",
            value: "1",
          },
          {
            label: "Redeemed",
            value: "2",
          },
          {
            label: "Used",
            value: "3",
          },
          {
            label: "Expired",
            value: "4",
          },
        ],
      },
    },
  ];
};

const columns = ({ permission, time_to_use, onSuccess }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Code</div>,
    accessor: "code",
  },
  {
    Header: <div style={{ textAlign: "left" }}>Status</div>,
    accessor: "status",
    Cell: (props) => REDER_REWARD_E_VOUCHER_STATUS(props.value),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Name</div>,
    accessor: "first_name",
    Cell: (props) => (
      <div>
        {!props.value
          ? "-"
          : `${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: props.value,
            })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: props.row.original?.member_detail?.last_name,
            })}`}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Phone</div>,
    accessor: "phone_number",
    Cell: (props) => <div>{!props.value ? "-" : `${props.value}`}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Time to use</div>,
    accessor: "time_to_use",
    Cell: (props) => <div>{`${props.value}`}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>used</div>,
    accessor: "used",
    Cell: (props) => <div>{`${props.value}`}</div>,
  },
  ...Array.from({ length: time_to_use }).map((e, i) => ({
    Header: <div style={{ textAlign: "left" }}>Used Date {i + 1}</div>,
    accessor: `used_list[${i}]`,
    Cell: (props) =>
      !props.value
        ? "-"
        : momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
  })),
  // {
  //   Header: <div style={{ textAlign: "left" }}>Used Date 1</div>,
  //   accessor: "used_date_1",
  //   Cell: (props) => (
  //     <div>
  //       {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
  //     </div>
  //   ),
  // },
  // {
  //   Header: <div style={{ textAlign: "left" }}>Used Date 2</div>,
  //   accessor: "used_date_2",
  //   Cell: (props) => (
  //     <div>
  //       {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
  //     </div>
  //   ),
  // },
  // {
  //   Header: <div style={{ textAlign: "left" }}>Used Date 3</div>,
  //   accessor: "used_date_3",
  //   Cell: (props) => (
  //     <div>
  //       {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
  //     </div>
  //   ),
  // },
  {
    Header: <div style={{ textAlign: "left" }}>Instrument</div>,
    accessor: "product_th",
    Cell: (props) => <div>{!props.value ? "-" : `${props.value}`}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>S/N</div>,
    accessor: "instrument_serial_no",
    Cell: (props) => <div>{!props.value ? "-" : `${props.value}`}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Add To Customer</div>,
    accessor: "add_to_customer",
    Cell: (props) =>
      props.row.original.status === "1" && (
        <div style={{ textAlign: "center" }}>
          <EVoucherAddToCusWidget
            reward_id={props.row.original.reward_ref_id}
            reward_e_voucher_id={props.row.original._id}
            onSuccess={onSuccess}
          />
        </div>
      ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RewardOfflineDetailContainer));
